import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";

const PageNotFound = () => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);


  return (
    <Wrapper id="login--wrapper">
      {/* <Header>Login</Header> */}
      <Container id="login--container">
        <Content>
          <ContentHeader>
            PictureViewer
            <span>by rndWs.com</span>
          </ContentHeader>
          <Title>
            404
            <span>page not found</span>
          </Title>
          
          <ButtonBelly>
            <span><Link to={BASE_URL +"/"}>Go to home page</Link></span>
          </ButtonBelly>
          
        </Content>
      </Container>
    </Wrapper>
  )
}

export default PageNotFound;

const Wrapper = styled.div `
  width: 100%;
  height: 90vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */
  min-height: 90vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div `
  /* text-align: center; */
`;

const Container = styled.div `
  width: 400px;
`;
const Content = styled.div `
  border: 1px solid orange;
  padding-bottom: 2rem;
  background-color: rgba(0,0,0,0.4);
`;
const ContentHeader = styled.div `
  display: flex;
  flex-direction: column;

  text-align: center;
  background-color: #111;
  padding: 2rem 3rem;
  line-height: 1.3rem;

  span {
    font-size: 1rem;
  }
`;
const Title = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-size: 1.6rem;
  padding: 1rem 2.4rem;

  span {
    font-size: 1rem;

    a {
      color: #3e85f5;
    }
  }

`;

const Form = styled.form `
  display: flex;
  flex-direction: column;
  
  padding: 1rem .5rem;

`;
const Input = styled.input `
  border: 1px solid #1b1b1b;
  background-color: #0e0e0e;
  color: #d1d1d1;
  font-size: 1.1rem;
  margin-top: .2rem;
  padding: 1rem .8rem;

`;
const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;
`;

const ButtonBelly = styled.div `
  font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  
  span {
    font-size: 1rem;
    color: #029F85;
  }
`;